// test290
(290 && 0);
